import { FunctionComponent } from 'react';
import {Card, Image} from 'react-bootstrap';
import styles from "./OverviewCard.module.css";
import cn from 'classnames';
import { ASSESTS } from '../../../constant/assest';

export enum IDifferenceType {
    INCREASE= 'incease',
    DECREASE= 'decrease',
};

interface IOverviewCardProps {
    title: string;
    value: string;
    icon: string;
    differenceType?: IDifferenceType;
    differenceText?: string;
    className?: string;
};

const OverviewCard: FunctionComponent<IOverviewCardProps> = ({title, value, icon, differenceType, differenceText,  className}) => {
    return (
        <Card bsPrefix={cn(styles.overviewCard, className)}>
            <Card.Header as={'div'} bsPrefix={styles.cardDataHeader}>
                <div className={styles.cardData}>
                    <Card.Title as={'div'} bsPrefix={styles.cardTitle}>{title}</Card.Title>
                    <Card.Text as={'div'} bsPrefix={styles.cardValue}>{value}</Card.Text>
                </div>
                <div className={styles.cardDataIcon}>
                    <Image src={icon} alt={title} />
                </div>
            </Card.Header>
            {differenceType && <Card.Footer as={'div'} bsPrefix={cn(styles.cardDataFooter, differenceType === IDifferenceType.INCREASE ? styles.increase : styles.decrease)}>
                <div className={styles.cardDataIcon}>
                    <Image src={differenceType === IDifferenceType.INCREASE ? ASSESTS.INCREASE : ASSESTS.DECREASE} alt='' />
                </div>
                <Card.Text as={'div'} bsPrefix={styles.cardDifference}>{differenceText}</Card.Text>
            </Card.Footer>}
        </Card>
    );
};

export default OverviewCard;
